var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ku-order-info"},[_c('van-overlay',{attrs:{"show":_vm.show}}),_c('van-loading',{staticStyle:{"z-index":"3"},attrs:{"type":"spinner","color":"#1989fa","vertical":""}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }